import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Select, { OnChangeValue } from 'react-select'
import './index.scss'
import clsx from 'clsx'
import FieldErrorSectionForm from '@App/kit/fields/v2/FieldErrorSectionForm'
import { SelectOption } from '@Components/Selectors/Select'
import getInputName from '@App/forms/v2/helpers/get-input-name'
import DropdownFormFieldProps from '@App/forms/v2/common/dropdown-form-field'
import { determineChangeValue } from '@App/common/utils'

const DropdownForm = (props: DropdownFormFieldProps) => {
    const { control, register } = useFormContext()
    const {
        options,
        mainColor = true,
        label,
        placeholder,
        className,
        showLabelOnSelect = true,
        isPhoneType = false,
        defaultValue,
        isClearable,
    } = props

    const theDefaultValue = defaultValue ? defaultValue : ''
    const depsNames = () => {
        if (props.validationDependency) {
            return props.validationDependency.map(getInputName)
        }
        return []
    }

    const inputName = getInputName(props)

    const registerResult = register(inputName, {
        deps: depsNames(),
    })

    return (
        <Controller
            name={inputName}
            control={control}
            defaultValue={theDefaultValue}
            render={({ field: { value, onChange, onBlur, ref, name }, fieldState }) => {
                const outerDivClassNames = clsx(
                    'dropdown-form-component',
                    mainColor ? 'main-color-set' : 'second-color-set',
                    className,
                    !!fieldState.error && 'error',
                    isPhoneType && 'phone-code-form-type',
                    !!label && !!placeholder && 'dropdown-padded-placeholder'
                )

                const selectedValue = value ? options?.find((opt) => opt.value === '' + value) : undefined

                // Show the label if there is a value, or placeholder text, and it's not explicitly disabled.
                const shouldShowLabel = (!!value || !!placeholder) && !!label && showLabelOnSelect

                return (
                    <>
                        <div className={outerDivClassNames} data-testid={inputName} role={`container-${inputName}`}>
                            {shouldShowLabel && (
                                <label className="dropdown-form-label" htmlFor={name}>
                                    {label}
                                </label>
                            )}
                            <div className="select-form-component">
                                <Select
                                    {...registerResult}
                                    inputId={name}
                                    name={name}
                                    key={`select-${name}-${value}`}
                                    ref={ref}
                                    options={options}
                                    placeholder={placeholder ? placeholder : label}
                                    value={selectedValue}
                                    onBlur={onBlur}
                                    onChange={(newValue: OnChangeValue<SelectOption, false>) =>
                                        onChange(determineChangeValue(newValue))
                                    }
                                    classNamePrefix="react-select"
                                    isClearable={!!isClearable}
                                />
                            </div>
                            <FieldErrorSectionForm {...props} fieldError={fieldState.error} />
                        </div>
                    </>
                )
            }}
        />
    )
}

export default DropdownForm
